/* eslint react/prop-types: off */
/* eslint no-unused-vars: off */

import corner4 from 'assets/img/illustrations/corner-4.png';
import Background from 'components/common/Background';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { widgetRegister } from 'data/widgets';
import React, {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle
} from 'react';
import { Card, Spinner } from 'react-bootstrap';
import { executeQuery } from 'services/dashboardService';
import PropTypes from 'prop-types';
import './widget.css';
import { API3_HOST, EVA_API_URL } from 'helpers/urlHelper';
import axios from 'axios';

/***
 * Component that wraps around every widget, handles passing data along and loading spinner .ect
 */
function widgetBody(isLoading, widget, component, data, options) {
  var hasNoQuery = !widget.queryId || widget.queryId == 0
  var hasNoRequest = !widget.requestUrl
  console.log("HasNoQuery", hasNoQuery, "HasNoRequest", hasNoRequest);

  if (hasNoQuery && hasNoRequest) {
    return <h5 className="text-danger text-center">No Query Assigned</h5>;
  } else if (isLoading) {
    return (
      <div className="text-center">
        <Spinner variant="primary" animation="border" role="status"></Spinner>
      </div>
    );
  } else if (data == null || Object.keys(data).length == 0) {
    return <h5 className="text-danger text-center">No Data</h5>;
  }

  return component(widget, data, options);
}

// WidgetWrapper component
// This component is a wrapper for the widgets in the dashboard. It handles loading data and displaying the widget.
function WidgetWrapper(
  { key, widget, onClick, onRightClick },
  ref
) {
  //const { widget, onClick, reload } = props;
  const widgetComponent = widgetRegister[widget.typeId].component;
  const hasValidQuery = widget.queryId && widget.queryId != 0;
  const hasRequestUrl = widget.requestMethod && widget.requestUrl;
  const clsName = `widget-wrapper-card ${widgetRegister[widget.typeId].cssClass
    }`;

  const loadWidgetData = () => {
    if (hasValidQuery) {
      setIsLoading(true);
      // 
      executeQuery(widget.queryId).then(res => {
        // 
        setData(res.data);
        setIsLoading(false);
      });
    }
    else if (hasRequestUrl) {
      setIsLoading(true);

      let url = widget.requestUrl;
      if (url[0] == '/') {
        url = API3_HOST + url;
      }

      console.log("WIDGET URL", url);

      const config = {
        method: widget.requestMethod,       // 'get', 'post', 'put', etc.
        url: url,
      };

      axios.get(url)
        .then(response => {
          setData(response.data);
        })
        .catch(error => {
          console.error('Error:', error);
        }).finally(() => {
          setIsLoading(false);
        });

    }
  };

  const divRef = useRef(null);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    // TODO: remove timeout and use a callback instead
    setTimeout(() => {
      loadWidgetData();
    }, 400);

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        setSize({
          width: entry.contentRect.width,
          height: entry.contentRect.height,
        });
      }
    });

    if (divRef.current) {
      resizeObserver.observe(divRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };

  }, []);

  // This effect will run when the reloadToken changes, indicating that the widget should be reloaded.
  useImperativeHandle(ref, () => ({
    reloadData() {
      loadWidgetData();
    }
  }));

  useEffect(() => {

  }, []);

  // Work out what the max height should be
  let correctedMaxHeight = size.height > 150 ? '100%' : '79%';
  let options = JSON.parse(widget.options);

  return (
    <Card
      ref={divRef}
      className={clsName}
      onContextMenu={e => {
        e.preventDefault();
        onClick();
      }}
    >

      {options && options.showBackgroundImage ? <Background image={corner4} className="bg-card" /> : <></>}
      <FalconCardHeader
        light
        title={`${widget.name}`}
        titleTag="h6"
        className="p-2"
      />
      <Card.Body className="p-0 m-0" style={{ maxHeight: correctedMaxHeight }}>
        {widgetBody(
          isLoading,
          widget,
          widgetComponent,
          data,
          options
        )}
      </Card.Body>
    </Card>
  );
}

// WidgetWrapper component forwardRef
// This allows the parent component to call the reloadData method on this component.
export default forwardRef(WidgetWrapper);

WidgetWrapper.propTypes = {
  widget: PropTypes.element,
  onClick: PropTypes.func,
  onRightClick: PropTypes.func
};
